import { useSearchParams } from 'react-router-dom';
import { useCustomerQuery } from 'src/app/customers/state/api/customersGraphSlice';
import { useProjectSamplingCadenceQuery } from 'src/app/projects/views/project-list/state/api/projectListGraphSlice';

const useSamplingCadenceAndCustomerData = () => {
    const [searchParams] = useSearchParams();
    const customerIdFromUrl = searchParams.get('customerId');
    const projectIdFromUrl = searchParams.get('projectId');
    const { currentData: customerData } = useCustomerQuery(
        {
            customerId: customerIdFromUrl || '',
        },
        {
            skip: !customerIdFromUrl,
        }
    );
    const { currentData: samplingCadence } = useProjectSamplingCadenceQuery(
        {
            projectId: projectIdFromUrl || '',
        },
        {
            skip: !projectIdFromUrl,
        }
    );

    return {
        samplingCadence,
        customerData,
    };
};

export default useSamplingCadenceAndCustomerData;
